/**
 * Imports the necessary dependencies for a React component that uses translation and
 * renders a Card component with custom breadcrumbs.
 * @module React
 * @module react-i18next
 * @module react-bootstrap/Card
 * @module ../../components/customBreadcrumb/customBreadcrumb
 * @returns None
 */
import React from "react";
import { Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { CardBody } from "reactstrap";

import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import EmptyCell from "../../components/emptyCell/emptyCell";

const NotificationComponent = (props) => {
  /**
   * Destructures the properties from the given props object.
   * @param {{object}} props - The props object containing the properties to destructure.
   * @returns None
   */
  const navigate = useNavigate();
  const {
    placeholder,
    read,
    onReadClick,
    notificationMap,
    dimensions,
    headerHeight,
    breadcrumbHeight,
    emptyImg,
  } = props;
  /**
   * Retrieves the translation function from the useTranslation hook.
   * @returns The translation function.
   */
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>Notification Management | RizzTix </title>
      </Helmet>
      <div className="pageContent notificationPage">
        <Breadcrumbs
          innerPagetitle={t("NOTIFICATION")}
          breadcrumbItem={t("NOTIFICATION")}
          BreadcrumbInner={false}
          BreadcrumbmainTitle={true}
          backArrow={true}
          onBackArrow={() => {
            navigate(-1);
          }}
        />
        <Card
          className="mainCard notification"
          style={{
            height:
              dimensions.width < 1279 &&
              dimensions.height - breadcrumbHeight - 200,
          }}
        >
          <Card.Body className="p-0 activeTab">
            <Col className="col-12">
              <Card className="mb-0 cardMain">
                <CardBody className="p-0 ">
                  {notificationMap?.length !== 0 && (
                    <div className="btnGroup">
                      <button
                        color="primary"
                        className={
                          read
                            ? "btn-block btn btn-primary whiteBtn hide"
                            : "btn-block btn btn-primary whiteBtn show"
                        }
                        onClick={() => onReadClick()}
                      >
                        <i className="bx bx-check"></i>
                        {t("MARK_ALL_AS_READ")}
                      </button>
                    </div>
                  )}
                  {notificationMap?.length !== 0 ? (
                    <div
                      className="notificationBox"
                      style={{
                        height:
                          dimensions.width > 1279
                            ? dimensions.height - headerHeight - 50
                            : dimensions.height - headerHeight - 100,
                      }}
                    >
                      <div>
                        {notificationMap?.map((item, index) => {
                          return (
                            <>
                              <div
                                key={index}
                                className={
                                  read
                                    ? "notificationRow readClass"
                                    : `notificationRow readClass ${item.unreadClass}`
                                }
                              >
                                <div className="detail">
                                  <div className="detailTitle">
                                    {placeholder && (
                                      <div className="shimer"></div>
                                    )}
                                    {item.title}
                                  </div>
                                  <div className="detailDesc">
                                    {placeholder && (
                                      <div className="shimer"></div>
                                    )}
                                    {item.discription}
                                  </div>
                                </div>
                                <div className="timing">
                                  <div className="detailTime">
                                    {placeholder && (
                                      <div className="shimer"></div>
                                    )}
                                    {item.date}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className="emptyNotificationBox">
                      <EmptyCell
                        emptyItems={notificationMap}
                        noDataAddButton={false}
                        emptyImg={emptyImg}
                        emptyTitle={t("NO_NOTIFICATION_YET")}
                        emptyDataDesc={t("YOU_HAVE_NO_NOTIFICATION_YET")}
                        emptyDataDescTow={t("PLEASE_COME_BACK_LATER")}
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Card.Body>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default NotificationComponent;
